import React from 'react';

// Components
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './FetchingBaProfile.scss';

const FetchingBaProfile = () => {
  const baseClassName = 'FetchingBaProfile';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__header`}>
        <div className={`${baseClassName}__header__icon`}>
          <LoadingShimmer shape="circle" width="45px" height="45px" />
        </div>
        <div className={`${baseClassName}__header__name`}>
          <LoadingShimmer shape="rectangle" width="130px" height="18px" />
        </div>
      </div>
      <div className={`${baseClassName}__description`}>
        <LoadingShimmer shape="rectangle" width="100%" height="14px" />
        <LoadingShimmer shape="rectangle" width="90%" height="14px" />
        <LoadingShimmer shape="rectangle" width="65%" height="14px" />
      </div>
      <div className={`${baseClassName}__graph`}>
        <LoadingShimmer shape="square" width="130px" height="75px" />
      </div>
      <div className={`${baseClassName}__title`}>
        <LoadingShimmer shape="rectangle" width="160px" height="18px" />
      </div>
      <div className={`${baseClassName}__description`}>
        <LoadingShimmer shape="rectangle" width="85%" height="14px" />
        <LoadingShimmer shape="rectangle" width="80%" height="14px" />
        <LoadingShimmer shape="rectangle" width="75%" height="14px" />
      </div>
    </div>
  );
};

export default FetchingBaProfile;
